/** @description url에서 특정 search params를 없애고 replace 합니다.  */
export const removeSearchParams = ({ name }: { name: string }) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(name);
  window.history.replaceState({}, '', url.toString());
};
